export default __webpack_public_path__ + "static/media/Black&YellowAIIcon.973829da.svg";